import { MOMENT_QUERY_FORMAT } from '@app/constants/Moment'

import type { Moment } from './moment'
import moment from './moment'

/**
 * Round date's minutes to be 00 or 30.abs
 *
 * Clones date.
 */
export function roundDate(date: Moment): Moment {
  const dc = date.clone().seconds(0)
  if ((date.minutes() === 0 || date.minutes() === 30) && date.seconds() === 0) return date.clone()

  if (dc.minutes() >= 30) {
    dc.minutes(0)
    dc.add(1, 'hour')
    return dc
  }

  dc.minutes(30)
  return dc
}

/**
 * @param date Moment instance
 * @param step granularity
 */
export function generateStartRange(date: Moment, step: number = 30): number[] {
  // Трасформируем дату в начало дня, для упрощения расчетов
  const roundedDate = roundDate(date)

  const startDate = moment.max(
    roundedDate.clone().add(2, 'hours'), // Cannot be earlier than now + 2 hours
    roundedDate.clone().startOf('day').add(6, 'hours') // Should be later than 6am
  )

  let minutes = startDate.hours() * 60 + startDate.minutes()

  const opts: number[] = []

  while (minutes <= 1440) {
    opts.push(minutes)
    minutes += step
  }

  return opts
}

/**
 * @param date Moment instance
 * @param step granularity
 */
export function generateEndRange(date: Moment, step: number = 30): number[] {
  const startDate = roundDate(date).add(1, 'hour')
  let minutes = startDate.hours() * 60 + startDate.minutes()

  if (minutes < 360) minutes += 1440

  const opts: number[] = []
  while (minutes <= 1560) {
    opts.push(minutes)
    minutes += step
  }

  return opts
}

/**
 * @Returns first available day for search.
 * It might be too late to search for today
 */
export function firstAvailableDay(now: Moment = moment()): Moment {
  if (now.hour() >= 22) return now.clone().add(1, 'day').startOf('day')

  return now.clone().startOf('day')
}

/**
 * Returns first available date rounded to 00/30 munites
 */
export function firstAvailableDate(forTime: Moment = moment()): Moment {
  const now = forTime.clone().seconds(0)
  if (now.hours() <= 3) return now.startOf('day').hours(6).minutes(0)

  return roundDate(now)
}

export function validateSearchParams(params: { date?: string | null }) {
  const { date } = params
  if (date) {
    const momentDate = moment(date, MOMENT_QUERY_FORMAT)
    if (momentDate && !momentDate.isBefore(firstAvailableDay(), 'day')) {
      return true
    }
  }
  return false
}

/**
 * converts time string in format "03:15" to moment object.
 * By default now is used.
 * @param dateJump if `true` time <= "06:00" counts as next day
 */
export function timeToMoment(time: string, date: Moment = moment(), dateJump: boolean = false): Moment {
  const parts = time.split(':').map(x => parseInt(x, 10)) as [number, number]
  const ndate = date.clone().startOf('day')
  if (parts[0] < 6 && dateJump) ndate.add(1, 'day')

  return ndate.hours(parts[0]).minutes(parts[1])
}

export function formatDate(date: string | Moment, dateFormat = 'DD MMMM YYYY', sameYearFormat = 'DD MMMM') {
  const m = moment(date)
  return m.format(m.isSame(moment(), 'year') ? sameYearFormat : dateFormat)
}
